import React, { Component } from "react";
import {
  Route,
  Switch,
  BrowserRouter as Router,
  withRouter,
} from "react-router-dom";

import VersionOne from "./components/version-one";

const getBasename = (path) => path.substr(0, path.lastIndexOf("/"));

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error("[ErrorBoundary]", error, info);
  }

  render() {
    if (this.state.error) {
      return (
        <div style={{ padding: "2rem", fontFamily: "sans-serif" }}>
          <h2 style={{ color: "#c00" }}>Something went wrong</h2>
          <p style={{ color: "#555", marginBottom: "0.5rem" }}>
            Please share this information with support:
          </p>
          <pre
            style={{
              background: "#f8f8f8",
              border: "1px solid #ddd",
              borderRadius: "4px",
              padding: "1rem",
              fontSize: "12px",
              overflowX: "auto",
              whiteSpace: "pre-wrap",
              wordBreak: "break-word",
              color: "#333"
            }}
          >
            {this.state.error.toString()}
            {"\n\nUser Agent: " + navigator.userAgent}
            {"\n\nURL: " + window.location.href}
          </pre>
          <button
            onClick={() => window.location.reload()}
            style={{
              marginTop: "1rem",
              padding: "0.6rem 1.4rem",
              background: "#f58220",
              color: "#fff",
              border: "none",
              borderRadius: "4px",
              fontSize: "15px",
              cursor: "pointer"
            }}
          >
            Try Again
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

class App extends Component {
  render() {
    return (
      <React.Fragment>
        <Router basename={getBasename(window.location.pathname)}>
          <ErrorBoundary>
            <Switch>
              <Route path="/" exact component={VersionOne} />
            </Switch>
          </ErrorBoundary>
        </Router>
      </React.Fragment>
    );
  }
}

export default withRouter(App);
